import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import Select from "react-select";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { withTranslation } from "react-i18next";
import {
  addGraderAssignStockList,
  getUserByRoleId,
  updateGraderAssignStock,
  getUserApi,
  getShapes,
  getInclusion,
  updateGraderStock,
  viewJangadTimeLine,
} from "api";
import * as Yup from "yup";
import {
  categoriTypes,
  status,
  color,
  purity,
  process,
} from "../StaticData.js";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { number } from "prop-types";
import moment from "moment";

class ViewJangadTimeline extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      isDisable: "",
      isSubmit: false,
      partyJangadNo: "",
      fillerList: [],
      jangadTimeline: {},
      shapesList: [],
      dataEntryOutwardStockList: [],
      jangadNo:
        props?.location?.query && props?.location?.query.isEdit == 2
          ? props?.location?.query.data.mainJangadId
          : "",
      inclusionList: [],
      salesOfficeDataentryList: [],
      selectedMulti: null,
      props: props?.location?.query,
      notEditableRows: [],
      stockList: [],
      graderOutWards: [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  validateTable() {
    for (let i = 0; i < this.state.stockList.length; i++) {
      let e = this.state.stockList[i];
      if (
        e.shapeId == "" ||
        e.iColorId == "" ||
        e.purityId == "" ||
        e.processId == "" ||
        e.ar == ""
      ) {
        return false;
      }
    }
    return true;
  }

  async componentDidMount() {
    console.log("this.state.props.isEdit", this.state.props);
    if (
      this.state.props &&
      this.state.props.isEdit &&
      this.state.props.isEdit == 2
    ) {
      const data = await viewJangadTimeLine({
        id: this.state.props.data.mainJangadId,
        isParty: "false",
        graderUserId: JSON.parse(localStorage.getItem("authUser")).id,
        partyJangadNo: null,
      });
      if (data)
        this.setState({
          jangadTimeline: data.data ? data.data : {},
        });

      const stockGraderOutWardsArray = data.data.jangads[0].stockGraderOutWards;
      const stockGraderOutwardInfo = [];
      stockGraderOutWardsArray.forEach(info => {
        const stockMachineOperatorInWard =
          data.data.jangads[0].stockMachineOperatorInWards.filter(
            y => info.stockMachineOperatorInWardId == y.id
          );
        stockMachineOperatorInWard.push({ graderOutward: info });
        stockGraderOutwardInfo.push(stockMachineOperatorInWard);
      });
      this.setState({
        graderOutWards: stockGraderOutwardInfo,
      });

      this.setState({
        dataEntryOutwardStockList:
          data.data.jangads[0].graderStock.stockGraderInWards.filter(
            x => x.stockDataEntryInWard.outwardDate !== null
          ),
      });
    }
    const shape = await getShapes();
    const inclusion = await getInclusion();

    const filler = await getUserApi({
      factoryId: "FAC0000002",
      roleId: "ROLE0000003",
    });
    this.setState(
      {
        fillerList: filler.data.users,
        shapesList: [
          { label: "NONE", value: "" },
          ...shape.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
        inclusionList: [
          ...inclusion.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      },
      () =>
        this.setState({
          stockList: this.state.stockList.map(x => {
            return {
              ...x,
              inclusionId:
                x.inclusionId == null
                  ? []
                  : this.state.inclusionList.filter(y =>
                      x.inclusionId.includes(y.value)
                    ),
            };
          }),
        })
    );
    this.validateTable();
  }

  async handleSubmit(e, values) {
    e.preventDefault();
  }

  _handleKeyDown = async (e, isParty) => {
    if (e.key === "Enter") {
      let id = e.target.value;
      const data = await viewJangadTimeLine({
        id: id.includes("JANGAD") ? id : "JANGAD" + id,
        isParty,
        graderUserId: JSON.parse(localStorage.getItem("authUser")).id,
        partyJangadNo: id,
      });
      if (data) {
        const stockGraderOutWardsArray =
          data.data.jangads[0].stockGraderOutWards;
        var stockGraderOutwardInfo = [];

        stockGraderOutWardsArray.forEach(info => {
          const stockMachineOperatorInWard =
            data.data.jangads[0].stockMachineOperatorInWards.filter(
              y => info.stockMachineOperatorInWardId == y.id
            );
          stockMachineOperatorInWard.push({ graderOutward: info });
          stockGraderOutwardInfo.push(stockMachineOperatorInWard);
        });
        this.setState({
          graderOutWards: stockGraderOutwardInfo,
        });

        this.setState(
          {
            jangadTimeline: data.data ? data.data : {},
          },
          () =>
            console.log("this.state.jangadTimeline", this.state.jangadTimeline)
        );

        this.setState(
          {
            dataEntryOutwardStockList:
              data.data.jangads[0].graderStock.stockGraderInWards.filter(
                x => x.stockDataEntryInWard.outwardDate !== null
              ),
          },
          () =>
            console.log(
              "this.state.dataEntryOutwardStockList",
              this.state.dataEntryOutwardStockList
            )
        );
      }
    }
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={this.props.t("View Jangad Timeline")}
            />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{}}
                validationSchema={Yup.object().shape({})}
                onSubmit={() => {}}
              >
                {({
                  errors,
                  status,
                  touched,
                  values,
                  isValid,
                  isValidating,
                  isSubmitting,
                  validateOnMount,
                  validateForm,
                  validateField,
                }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              {this.props.t("View Jangad Timeline")}
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>

                        <CardBody>
                          <div className="row">
                            <div className="col-xl-8 col-12">
                              <CardBody>
                                <Row>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="partyJangadNo"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Party Jangad No")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        onKeyDown={e =>
                                          this._handleKeyDown(e, "true")
                                        }
                                        className={
                                          "form-control fs-5" +
                                          (errors.partyJangadNo &&
                                          touched.partyJangadNo
                                            ? " is-invalid"
                                            : "")
                                        }
                                        value={this.state.partyJangadNo}
                                        onChange={e => {
                                          this.setState({
                                            partyJangadNo: e.target.value,
                                          });
                                        }}
                                        type="text"
                                        name="partyJangadNo"
                                        placeholder="123"
                                      />
                                      <ErrorMessage
                                        name="partyJangadNo"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="partyCode"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Party Code")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className="form-control fs-5"
                                        value={
                                          this.state.jangadTimeline?.party
                                            ?.partyCode
                                        }
                                        readOnly={true}
                                        type="text"
                                        name="partyCode"
                                        placeholder="JANGAD0000123"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="category"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Diamond Category")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className="form-control fs-5"
                                        value={
                                          this.state.jangadTimeline?.category
                                            ?.name
                                        }
                                        readOnly={true}
                                        type="text"
                                        name="category"
                                        placeholder="JANGAD0000123"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="pieces"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Pieces")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      {this.state.jangadTimeline.jangads ? (
                                        <Field
                                          className="form-control fs-5"
                                          value={
                                            this.state.jangadTimeline.jangads[0]
                                              .pieces
                                          }
                                          readOnly={true}
                                          type="text"
                                          name="pieces"
                                          placeholder="Pieces"
                                        />
                                      ) : (
                                        <Field
                                          className="form-control fs-5"
                                          value={
                                            this.state.props?.data?.jangad
                                              ?.pieces
                                          }
                                          readOnly={true}
                                          type="text"
                                          name="pieces"
                                          placeholder="Pieces"
                                        />
                                      )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="weight"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Weight")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      {this.state.jangadTimeline.jangads ? (
                                        <Field
                                          className="form-control fs-5"
                                          value={
                                            this.state.jangadTimeline.jangads[0]
                                              .weight
                                          }
                                          readOnly={true}
                                          type="text"
                                          name="weight"
                                          placeholder="weight"
                                        />
                                      ) : (
                                        <Field
                                          className="form-control fs-5"
                                          value={
                                            this.state.props?.data?.jangad
                                              ?.weight
                                          }
                                          readOnly={true}
                                          type="text"
                                          name="weight"
                                          placeholder="weight"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </Row>
                              </CardBody>
                            </div>
                            <div className="col-xl-4 col-12 pt-3">
                              <div className="px-4">
                                <div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="jangadNo"
                                      className="col-md-4 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Jangad No")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-8">
                                      <Field
                                        onKeyDown={e =>
                                          this._handleKeyDown(e, "false")
                                        }
                                        className={
                                          "form-control fs-5" +
                                          (errors.jangadNo && touched.jangadNo
                                            ? " is-invalid"
                                            : "")
                                        }
                                        value={
                                          this.state.props?.isEdit == 2
                                            ? parseInt(
                                                this.state.jangadNo.split(
                                                  "JANGAD"
                                                )[1]
                                              )
                                            : this.state.jangadNo
                                        }
                                        onChange={e => {
                                          this.setState({
                                            jangadNo: e.target.value,
                                          });
                                        }}
                                        type="text"
                                        name="jangadNo"
                                        placeholder="1"
                                      />
                                      <ErrorMessage
                                        name="jangadNo"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </div>
                      <>
                        <div className="row px-3 pt-3">
                          <div className="col-xxl-5 col-12">
                            <h2 className="text-black">
                              {this.props.t("Jangad Timeline")}
                            </h2>
                          </div>
                          <div className="col-xxl-7 col-12 d-lg-flex d-block justify-content-between">
                            <h5 className="d-lg-inline d-block pt-4 pt-lg-0 fw-bold">
                              <span className="py-1 px-3 me-3 rounded-circle btn-success-green"></span>
                              {this.props.t("Successfully Assign / Accept")}
                            </h5>
                            <h5 className="d-lg-inline d-block pt-4 pt-lg-0 fw-bold">
                              <span className="py-1 px-3 me-3 rounded-circle btn-orange"></span>{" "}
                              {this.props.t("Pending Assign / Accept")}
                            </h5>
                            <h5 className="d-lg-inline d-block pt-4 pt-lg-0 fw-bold">
                              {" "}
                              <span className="py-1 px-3 me-3 rounded-circle btn-pink"></span>{" "}
                              {this.props.t("Cancel Return")}
                            </h5>
                          </div>
                        </div>
                        {this.state.jangadTimeline?.jangads?.map(x => {
                          let salesofficeCreatedDate = moment(x.createdAt);
                          let salesofficeUpdatedDate = moment(x.updatedAt);

                          let dataentryCreatedDate = moment(
                            x.dataEntryStock?.createdAt
                          );
                          let dataentryUpdatedDate = moment(
                            x.dataEntryStock?.updatedAt
                          );
                          let graderCreatedDate = moment(
                            x.graderStock?.createdAt
                          );
                          let graderUpdatedDate = moment(
                            x.graderStock?.updatedAt
                          );
                          let fillerCreatedDate = moment(
                            x.fillerStock?.createdAt
                          );
                          let fillerUpdatedDate = moment(
                            x.fillerStock?.updatedAt
                          );
                          let machineOperatorCreatedDate = moment(
                            x.cubeInformation?.cubeBelt?.machineOperatorStock
                              ?.createdAt
                          );
                          let machineOperatorUpdatedDate = moment(
                            x.cubeInformation?.cubeBelt?.machineOperatorStock
                              ?.updatedAt
                          );

                          return (
                            <>
                              <div className="text-center pt-3">
                                <h4 className="text-black">
                                  {this.props.t("Jangad Cycle")} - {x.cycle}
                                </h4>
                              </div>
                              <div className="mx-3 px-3 border border-1 mt-4 border-dark">
                                {/* <h4 className="text-center fw-bold pt-3">
                                  Sales office & Data Entry Office
                                </h4>
                                <div className="table-responsive">
                                  <table className="table border background-light foo border-1">
                                    <thead>
                                      <tr>
                                        <th scope="col">Office</th>
                                        <th scope="col">Person Name</th>
                                        <th scope="col">Accept Time</th>
                                        <th scope="col">Assign Time</th>
                                        <th scope="col">Hold Time</th>
                                        <th scope="col">Delay Time</th>
                                      </tr>
                                    </thead>

                                    <tbody
                                      className={
                                        x.dataEntryStatus == "A"
                                          ? "bg-success-green"
                                          : "btn-orange"
                                      }
                                    >
                                      <tr>
                                        <td scope="row">Sales Office</td>
                                        <td>{x.user.name}</td>
                                        <td>-</td>
                                        <td>
                                          {salesofficeCreatedDate.format(
                                            "YYYY-MM-DD hh:mm:ss A"
                                          )}
                                        </td>
                                        <td>-</td>
                                        <td>-</td>
                                      </tr>
                                      {x.dataEntryStock != null && (
                                        <tr>
                                          <td scope="row">Data Entry</td>
                                          <td>{x.dataEntryStock.user.name}</td>
                                          <td>
                                            {dataentryCreatedDate.format(
                                              "YYYY-MM-DD hh:mm:ss A"
                                            )}
                                          </td>
                                          <td>
                                            {dataentryUpdatedDate.format(
                                              "YYYY-MM-DD hh:mm:ss A"
                                            )}
                                          </td>
                                          <td>
                                            {moment
                                              .utc(
                                                +moment.duration(
                                                  dataentryUpdatedDate.diff(
                                                    dataentryCreatedDate
                                                  )
                                                )
                                              )
                                              .format("H:mm:ss")}
                                          </td>
                                          <td>
                                            {moment
                                              .utc(
                                                +moment.duration(
                                                  dataentryCreatedDate.diff(
                                                    salesofficeCreatedDate
                                                  )
                                                )
                                              )
                                              .format("H:mm:ss")}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>

                                  {x.dataEntryStock != null && (
                                    <>
                                      <h4 className="text-center fw-bold pt-3">
                                        Data Entry Stock
                                      </h4>
                                      <div className="table-responsive">
                                        <table className="table border background-light foo border-1">
                                          <thead>
                                            <tr>
                                              <th scope="col">SR No.</th>
                                              <th scope="col">
                                                Weight / Carat
                                              </th>
                                              <th scope="col">Pieces</th>
                                              <th scope="col">Accept Time</th>
                                              <th scope="col">Assign Time</th>
                                              <th scope="col">Hold Time</th>
                                              <th scope="col">Delay Time</th>
                                            </tr>
                                          </thead>
                                          {x.dataEntryStock?.stockDataEntryInWards?.map(
                                            (y, index) => {
                                              return (
                                                <tbody
                                                  className={
                                                    x.dataEntryStatus == "A"
                                                      ? "bg-success-green"
                                                      : "btn-orange"
                                                  }
                                                  key={index}
                                                >
                                                  <tr>
                                                    <td scope="row">
                                                      {y.srNo}
                                                    </td>
                                                    <td>{y.weight}</td>

                                                    <td>{y.pieces}</td>
                                                    <td>
                                                      {moment(
                                                        y.createdAt
                                                      ).format("hh:mm:ss A")}
                                                    </td>
                                                    <td>
                                                      {moment(
                                                        y.updatedAt
                                                      ).format("hh:mm:ss A")}
                                                    </td>
                                                    <td>
                                                      {moment
                                                        .utc(
                                                          +moment.duration(
                                                            moment(
                                                              y.updatedAt
                                                            ).diff(
                                                              moment(
                                                                y.createdAt
                                                              )
                                                            )
                                                          )
                                                        )
                                                        .format("H:mm:ss")}
                                                    </td>
                                                    <td>
                                                      {moment
                                                        .utc(
                                                          +moment.duration(
                                                            moment(
                                                              y.createdAt).diff(
                                                              moment(
                                                                salesofficeUpdatedDate
                                                              )
                                                            )
                                                          )
                                                        )
                                                        .format("H:mm:ss")}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              );
                                            }
                                          )}
                                        </table>
                                      </div>
                                    </>
                                  )}
                                </div> */}
                                {x.dataEntryStock != null &&
                                  x.graderStock != null && (
                                    <>
                                      <h4 className="text-center fw-bold pt-3">
                                        {this.props.t("Grader")}
                                      </h4>
                                      <div className="table-responsive">
                                        <table className="table border background-light foo border-1">
                                          <thead>
                                            <tr>
                                              <th scope="col">
                                                {this.props.t("Office")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Person Name")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Self Remarks")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Next Remarks")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Accept Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Assign Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Hold Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Delay Time")}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody
                                            className={
                                              x.dataEntryStock.graderStatus ==
                                              "A"
                                                ? "bg-success-green"
                                                : x.dataEntryStock
                                                    .graderStatus == "P"
                                                ? "btn-orange"
                                                : "btn-orange"
                                            }
                                          >
                                            <tr>
                                              <td scope="row">
                                                {this.props.t("Grader")}
                                              </td>
                                              <td>
                                                {x.graderStock?.user?.name}
                                              </td>
                                              <td>{x.graderStock?.remarks}</td>
                                              <td>
                                                {x.graderStock?.nextRemarks}
                                              </td>
                                              <td>
                                                {graderCreatedDate.format(
                                                  "YYYY-MM-DD hh:mm:ss A"
                                                )}
                                              </td>
                                              <td>
                                                {graderUpdatedDate.format(
                                                  "YYYY-MM-DD hh:mm:ss A"
                                                )}
                                              </td>
                                              <td>
                                                {moment
                                                  .utc(
                                                    +moment.duration(
                                                      graderUpdatedDate.diff(
                                                        graderCreatedDate
                                                      )
                                                    )
                                                  )
                                                  .format("H:mm:ss")}
                                              </td>
                                              <td>
                                                {moment
                                                  .utc(
                                                    +moment.duration(
                                                      graderCreatedDate.diff(
                                                        dataentryCreatedDate
                                                      )
                                                    )
                                                  )
                                                  .format("H:mm:ss")}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <>
                                        <div className="table-responsive">
                                          <table className="table border background-light foo border-1">
                                            <thead>
                                              <tr>
                                                <th scope="col">
                                                  {this.props.t("SR No.")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Pieces")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t(
                                                    "Weight / Carat"
                                                  )}
                                                </th>

                                                <th scope="col">
                                                  {this.props.t("Shape")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Color")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Purity")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Inclusion")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Self Remarks")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Accept Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Assign Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Hold Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Delay Time")}
                                                </th>
                                              </tr>
                                            </thead>
                                            {x.graderStock?.stockGraderInWards
                                              ?.sort(
                                                (a, b) =>
                                                  a.stockDataEntryInWard.srNo -
                                                  b.stockDataEntryInWard.srNo
                                              )
                                              .map((y, index) => {
                                                return (
                                                  <tbody key={index}>
                                                    <tr>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y.stockDataEntryInWard
                                                            .srNo
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {
                                                          y.stockDataEntryInWard
                                                            .pieces
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {y.weight}
                                                      </td>

                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {y.shape.name}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {color.filter(z => {
                                                          return (
                                                            z.value ==
                                                            y.iColorId
                                                          );
                                                        }).length
                                                          ? color.filter(z => {
                                                              return (
                                                                z.value ==
                                                                y.iColorId
                                                              );
                                                            })[0].label
                                                          : ""}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {purity.filter(z => {
                                                          return (
                                                            z.value ==
                                                            y.purityId
                                                          );
                                                        }).length
                                                          ? purity.filter(z => {
                                                              return (
                                                                z.value ==
                                                                y.purityId
                                                              );
                                                            })[0].label
                                                          : ""}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {y.inclusionId &&
                                                        this.state.inclusionList.filter(
                                                          z => {
                                                            return y.inclusionId.includes(
                                                              z.value
                                                            );
                                                          }
                                                        ).length
                                                          ? this.state.inclusionList
                                                              .filter(z => {
                                                                return y.inclusionId.includes(
                                                                  z.value
                                                                );
                                                              })
                                                              .map(x => {
                                                                return x.label;
                                                              })
                                                          : ""}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {y.remarks}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {moment(
                                                          y.createdAt
                                                        ).format("hh:mm:ss A")}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {moment(
                                                          y.updatedAt
                                                        ).format("hh:mm:ss A")}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {moment
                                                          .utc(
                                                            +moment.duration(
                                                              moment(
                                                                y.updatedAt
                                                              ).diff(
                                                                moment(
                                                                  y.createdAt
                                                                )
                                                              )
                                                            )
                                                          )
                                                          .format("H:mm:ss")}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.ar == true &&
                                                          y.stockFillerInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : y.ar == true &&
                                                              y.stockFillerInWard ==
                                                                null
                                                            ? "btn-orange"
                                                            : "btn-pink"
                                                        }
                                                      >
                                                        {moment
                                                          .utc(
                                                            +moment.duration(
                                                              moment(
                                                                y.createdAt
                                                              ).diff(
                                                                dataentryUpdatedDate
                                                              )
                                                            )
                                                          )
                                                          .format("H:mm:ss")}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                );
                                              })}
                                          </table>
                                        </div>
                                      </>

                                      {x.assignGraderToFillerStock != null && (
                                        <>
                                          <h4 className="text-center fw-bold pt-3">
                                            {this.props.t(
                                              "Assign Grader To Filler"
                                            )}
                                          </h4>
                                          <div className="table-responsive">
                                            <table className="table border background-light foo border-1">
                                              <thead>
                                                <tr>
                                                  <th scope="col">
                                                    {this.props.t("SR No.")}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t("Pieces")}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t(
                                                      "Weight / Carat"
                                                    )}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t("Shape")}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t("Cycle")}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t("Process")}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t(
                                                      "Data Entry Status"
                                                    )}
                                                  </th>

                                                  <th scope="col">
                                                    {this.props.t(
                                                      "Self Remarks"
                                                    )}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t(
                                                      "Next Remarks"
                                                    )}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t(
                                                      "Accept Time"
                                                    )}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t(
                                                      "Assign Time"
                                                    )}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t("Hold Time")}
                                                  </th>
                                                  <th scope="col">
                                                    {this.props.t("Delay Time")}
                                                  </th>
                                                </tr>
                                              </thead>
                                              {x.assignGraderToFillerStock?.assignGraderToFillerInWards
                                                ?.filter(
                                                  x =>
                                                    x.stockGraderInWard.ar ==
                                                    true
                                                )
                                                .sort((a, b) => a.srNo - b.srNo)
                                                .map((y, index) => {
                                                  return (
                                                    <tbody key={index}>
                                                      <tr>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                          scope="row"
                                                        >
                                                          {
                                                            y
                                                              .stockDataEntryInWard
                                                              .srNo
                                                          }
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {
                                                            y
                                                              .stockDataEntryInWard
                                                              .pieces
                                                          }
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {y.weight}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {
                                                            y.stockGraderInWard
                                                              .shape.name
                                                          }
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {y.cycle}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {y.process.name}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {y.cycle != 1
                                                            ? y.dataEntryStatus ==
                                                              "P"
                                                              ? "Pending"
                                                              : y.dataEntryStatus ==
                                                                "A"
                                                              ? "Accept"
                                                              : "Reject"
                                                            : "-"}
                                                        </td>

                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {y.remarks}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {y.nextRemarks}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {moment(
                                                            y.createdAt
                                                          ).format(
                                                            "hh:mm:ss A"
                                                          )}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {moment(
                                                            y.updatedAt
                                                          ).format(
                                                            "hh:mm:ss A"
                                                          )}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {moment
                                                            .utc(
                                                              +moment.duration(
                                                                moment(
                                                                  y.updatedAt
                                                                ).diff(
                                                                  moment(
                                                                    y.createdAt
                                                                  )
                                                                )
                                                              )
                                                            )
                                                            .format("H:mm:ss")}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.stockFillerInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : y.stockFillerInWard ==
                                                                null
                                                              ? "btn-orange"
                                                              : "btn-pink"
                                                          }
                                                        >
                                                          {moment
                                                            .utc(
                                                              +moment.duration(
                                                                moment(
                                                                  y.updatedAt
                                                                ).diff(
                                                                  moment(
                                                                    y.createdAt
                                                                  )
                                                                )
                                                              )
                                                            )
                                                            .format("H:mm:ss")}
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  );
                                                })}
                                            </table>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}

                                {x.dataEntryStock != null &&
                                  x.graderStock != null &&
                                  x.fillerStock != null && (
                                    <>
                                      <h4 className="text-center fw-bold pt-3">
                                        {this.props.t("Filler")}
                                      </h4>
                                      <div className="table-responsive">
                                        <table className="table border background-light foo border-1">
                                          <thead>
                                            <tr>
                                              <th scope="col">
                                                {this.props.t("Office")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Person Name")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Self Remarks")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Next Remarks")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Accept Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Assign Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Hold Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Delay Time")}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody
                                            className={
                                              x.assignGraderToFillerStock
                                                .fillerStatus == "A"
                                                ? "bg-success-green"
                                                : x.assignGraderToFillerStock
                                                    .fillerStatus == "P"
                                                ? "btn-orange"
                                                : "btn-orange"
                                            }
                                          >
                                            <tr>
                                              <td scope="row">
                                                {this.props.t("Filler")}
                                              </td>
                                              <td>
                                                {x.fillerStock?.user?.name}
                                              </td>
                                              <td>{x.fillerStock?.remarks}</td>
                                              <td>
                                                {x.fillerStock?.nextRemarks}
                                              </td>
                                              <td>
                                                {moment(
                                                  x.fillerStock?.createdAt
                                                ).format(
                                                  "YYYY-MM-DD hh:mm:ss A"
                                                )}
                                              </td>
                                              <td>
                                                {moment(
                                                  x.cubeInformation?.cubeBelt
                                                    ?.createdAt
                                                ).format(
                                                  "YYYY-MM-DD hh:mm:ss A"
                                                )}
                                              </td>
                                              <td>
                                                {moment
                                                  .utc(
                                                    +moment.duration(
                                                      moment(
                                                        x.cubeInformation
                                                          ?.cubeBelt?.createdAt
                                                      ).diff(
                                                        moment(
                                                          x.fillerStock
                                                            ?.createdAt
                                                        )
                                                      )
                                                    )
                                                  )
                                                  .format("H:mm:ss")}
                                              </td>
                                              <td>
                                                {moment
                                                  .utc(
                                                    +moment.duration(
                                                      fillerCreatedDate.diff(
                                                        graderUpdatedDate
                                                      )
                                                    )
                                                  )
                                                  .format("H:mm:ss")}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <>
                                        <div className="table-responsive">
                                          <table className="table border background-light foo border-1">
                                            <thead>
                                              <tr>
                                                <th scope="col">
                                                  {this.props.t("SR No.")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Cube Id")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Filler Name")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Pieces")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t(
                                                    "Weight / Carat"
                                                  )}
                                                </th>

                                                <th scope="col">
                                                  {this.props.t("Cycle")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Process")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Accept Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Assign Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Hold Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Delay Time")}
                                                </th>
                                              </tr>
                                            </thead>
                                            {x.fillerStock?.stockFillerInWards
                                              .sort(
                                                (a, b) =>
                                                  a?.cubeInformation?.cubeBelt?.cubeId?.split(
                                                    "-"
                                                  )[1] -
                                                  b?.cubeInformation?.cubeBelt?.cubeId?.split(
                                                    "-"
                                                  )[1]
                                              )
                                              .map((y, index) => {
                                                return (
                                                  <tbody key={index}>
                                                    <tr>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y.stockDataEntryInWard
                                                            .srNo
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {y.cubeInformation !=
                                                        null
                                                          ? y.cubeInformation
                                                              .cubeBelt.cubeId
                                                          : "-"}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {y.cubeInformation !=
                                                        null
                                                          ? y.cubeInformation
                                                              .cubeBelt?.user
                                                              .name
                                                          : "-"}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {
                                                          y.stockDataEntryInWard
                                                            .pieces
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {
                                                          y.stockGraderInWard
                                                            .weight
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y
                                                            .assignGraderToFillerInWard
                                                            .cycle
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y
                                                            .assignGraderToFillerInWard
                                                            .process.name
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {moment(
                                                          y.createdAt
                                                        ).format("hh:mm:ss A")}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {y.cubeInformation !=
                                                        null
                                                          ? moment(
                                                              y.cubeInformation
                                                                .updatedAt
                                                            ).format(
                                                              "hh:mm:ss A"
                                                            )
                                                          : "-"}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {y.cubeInformation !=
                                                        null
                                                          ? moment
                                                              .utc(
                                                                +moment.duration(
                                                                  moment(
                                                                    y
                                                                      .cubeInformation
                                                                      .updatedAt
                                                                  ).diff(
                                                                    moment(
                                                                      y.createdAt
                                                                    )
                                                                  )
                                                                )
                                                              )
                                                              .format("H:mm:ss")
                                                          : "-"}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.cubeInformation !=
                                                            null &&
                                                          y.cubeInformation
                                                            .stockMachineOperatorInWard !=
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {moment
                                                          .utc(
                                                            +moment.duration(
                                                              moment(
                                                                y.createdAt
                                                              ).diff(
                                                                moment(
                                                                  y
                                                                    .assignGraderToFillerInWard
                                                                    .createdAt
                                                                )
                                                              )
                                                            )
                                                          )
                                                          .format("H:mm:ss")}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                );
                                              })}
                                          </table>
                                        </div>
                                      </>
                                    </>
                                  )}

                                {x.dataEntryStock != null &&
                                  x.graderStock != null &&
                                  x.fillerStock != null &&
                                  x.stockMachineOperatorInWards != null && (
                                    <>
                                      <h4 className="text-center fw-bold pt-3">
                                        {this.props.t("Machine operator")}
                                      </h4>
                                      {/* <h4 className="text-center fw-bold pt-3">
                                        {this.props.t("Machine operator")}
                                      </h4>
                                      <div className="table-responsive">
                                        <table className="table border table-responsive background-light foo border-1">
                                          <thead>
                                            <tr>
                                              <th scope="col">
                                                {this.props.t("Office")}
                                              </th>                                              
                                              <th scope="col">
                                                {this.props.t("Accept Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Assign Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Hold Time")}
                                              </th>
                                              <th scope="col">
                                                {this.props.t("Delay Time")}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody
                                            className={
                                              x.stockMachineOperatorInWard !=
                                              null
                                                ? "bg-success-green"
                                                : "btn-orange"
                                            }
                                          >
                                            <tr>
                                              <td scope="row">
                                                {this.props.t(
                                                  "Machine operator"
                                                )}
                                              </td>
                                              <td>
                                                {moment(
                                                  x.cubeInformation?.cubeBelt
                                                    .machineOperatorStock
                                                    ?.createdAt
                                                ).format(
                                                  "YYYY-MM-DD hh:mm:ss A"
                                                )}
                                              </td>
                                              <td>
                                                {moment(
                                                  x.cubeInformation?.cubeBelt
                                                    .machineOperatorStock
                                                    ?.updatedAt
                                                ).format(
                                                  "YYYY-MM-DD hh:mm:ss A"
                                                )}
                                              </td>
                                              <td>
                                                {moment
                                                  .utc(
                                                    +moment.duration(
                                                      machineOperatorUpdatedDate.diff(
                                                        machineOperatorCreatedDate
                                                      )
                                                    )
                                                  )
                                                  .format("H:mm:ss")}
                                              </td>
                                              <td>
                                                {moment
                                                  .utc(
                                                    +moment.duration(
                                                      machineOperatorCreatedDate.diff(
                                                        fillerUpdatedDate
                                                      )
                                                    )
                                                  )
                                                  .format("H:mm:ss")}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div> */}
                                      <>
                                        <div className="table-responsive">
                                          <table className="table border table-responsive background-light foo border-1">
                                            <thead>
                                              <tr>
                                                <th scope="col">
                                                  {this.props.t("SR No.")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Cube Id")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t(
                                                    "Machine User Name"
                                                  )}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Pieces")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t(
                                                    "Weight / Carat"
                                                  )}
                                                </th>

                                                <th scope="col">
                                                  {this.props.t("Cycle")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Process")}
                                                </th>
                                                {/* <th scope="col">
                                                  {this.props.t("Shape")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Color")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Purity")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Inclusion")}
                                                </th> */}
                                                <th scope="col">
                                                  {this.props.t("Accept Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Assign Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Hold Time")}
                                                </th>
                                                <th scope="col">
                                                  {this.props.t("Delay Time")}
                                                </th>
                                              </tr>
                                            </thead>
                                            {x.stockMachineOperatorInWards
                                              .sort(
                                                (a, b) =>
                                                  a?.cubeBelt?.cubeId?.split(
                                                    "-"
                                                  )[1] -
                                                  b?.cubeBelt?.cubeId?.split(
                                                    "-"
                                                  )[1]
                                              )
                                              .map((y, index) => {
                                                return (
                                                  <tbody key={index}>
                                                    <tr>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y.stockDataEntryInWard
                                                            .srNo
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {y?.cubeBelt?.cubeId}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y.machineOperatorStock
                                                            .user.name
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {
                                                          y.stockDataEntryInWard
                                                            .pieces
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {
                                                          y.stockGraderInWard
                                                            .weight
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y
                                                            .assignGraderToFillerInWard
                                                            .cycle
                                                        }
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                        scope="row"
                                                      >
                                                        {
                                                          y
                                                            .assignGraderToFillerInWard
                                                            .process.name
                                                        }
                                                      </td>
                                                      {/* 
                                                        <td
                                                          className={
                                                            y.cubeInformation
                                                              .stockMachineOperatorInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : "btn-orange"
                                                          }
                                                        >
                                                          {
                                                            y.stockGraderInWard
                                                              .shape.name
                                                          }
                                                        </td>
                                                        <td
                                                          className={
                                                            y.cubeInformation
                                                              .stockMachineOperatorInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : "btn-orange"
                                                          }
                                                        >
                                                          {color.filter(z => {
                                                            return (
                                                              z.value ==
                                                              y
                                                                .stockGraderInWard
                                                                .iColorId
                                                            );
                                                          }).length
                                                            ? color.filter(
                                                                z => {
                                                                  return (
                                                                    z.value ==
                                                                    y
                                                                      .stockGraderInWard
                                                                      .iColorId
                                                                  );
                                                                }
                                                              )[0].label
                                                            : ""}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.cubeInformation
                                                              .stockMachineOperatorInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : "btn-orange"
                                                          }
                                                        >
                                                          {purity.filter(z => {
                                                            return (
                                                              z.value ==
                                                              y
                                                                .stockGraderInWard
                                                                .purityId
                                                            );
                                                          }).length
                                                            ? purity.filter(
                                                                z => {
                                                                  return (
                                                                    z.value ==
                                                                    y
                                                                      .stockGraderInWard
                                                                      .purityId
                                                                  );
                                                                }
                                                              )[0].label
                                                            : ""}
                                                        </td>
                                                        <td
                                                          className={
                                                            y.cubeInformation
                                                              .stockMachineOperatorInWard !=
                                                            null
                                                              ? "bg-success-green"
                                                              : "btn-orange"
                                                          }
                                                        >
                                                          {y.stockGraderInWard.inclusionId && this.state.inclusionList.filter(
                                                            z => {
                                                              return y.stockGraderInWard.inclusionId.includes(
                                                                z.value
                                                              );
                                                            }
                                                          ).length
                                                            ? this.state.inclusionList
                                                                .filter(z => {
                                                                    return y.stockGraderInWard.inclusionId.includes(
                                                                    z.value
                                                                  );                                                             
                                                                })
                                                                .map(x => {
                                                                  return x.label;
                                                                })
                                                            : ""}
                                                        </td> */}
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {moment(
                                                          y?.createdAt
                                                        ).format("hh:mm:ss A")}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {moment(
                                                          y.updatedAt
                                                        ).format("hh:mm:ss A")}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {moment
                                                          .utc(
                                                            +moment.duration(
                                                              moment(
                                                                y.updatedAt
                                                              ).diff(
                                                                moment(
                                                                  y.createdAt
                                                                )
                                                              )
                                                            )
                                                          )
                                                          .format("H:mm:ss")}
                                                      </td>
                                                      <td
                                                        className={
                                                          y.graderStatus ==
                                                            "A" ||
                                                          y.machineOperatorStock
                                                            .boilManUserId ==
                                                            null
                                                            ? "bg-success-green"
                                                            : "btn-orange"
                                                        }
                                                      >
                                                        {moment
                                                          .utc(
                                                            +moment.duration(
                                                              moment(
                                                                fillerUpdatedDate
                                                              ).diff(
                                                                y.createdAt
                                                              )
                                                            )
                                                          )
                                                          .format("H:mm:ss")}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                );
                                              })}
                                          </table>
                                        </div>
                                      </>
                                    </>
                                  )}
                                {this.state.graderOutWards != null && (
                                  <>
                                    <h4 className="text-center fw-bold pt-3">
                                      {this.props.t("Grader Outward Stock")}
                                    </h4>
                                    <div className="table-responsive">
                                      <table className="table border table-responsive background-light foo border-1">
                                        <thead>
                                          <tr>
                                            <th scope="col">
                                              {this.props.t("Office")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Accept Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Assign Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Hold Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Delay Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t(
                                                "Total Outward Weight"
                                              )}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            className={
                                              x.graderOutWardStock != null
                                                ? "bg-success-green"
                                                : "btn-orange"
                                            }
                                          >
                                            {x.graderOutWardStock != null && (
                                              <>
                                                <td scope="row">
                                                  {" "}
                                                  {this.props.t("Grader")}{" "}
                                                </td>

                                                <td>
                                                  {moment(
                                                    x.graderOutWardStock
                                                      .createdAt
                                                  ).format("hh:mm:ss A")}
                                                </td>
                                                <td>
                                                  {moment(
                                                    x.graderOutWardStock
                                                      .updatedAt
                                                  ).format("hh:mm:ss A")}
                                                </td>
                                                <td>
                                                  {" "}
                                                  {moment
                                                    .utc(
                                                      +moment.duration(
                                                        moment(
                                                          x.graderOutWardStock
                                                            .updatedAt
                                                        ).diff(
                                                          moment(
                                                            x.graderOutWardStock
                                                              .createdAt
                                                          )
                                                        )
                                                      )
                                                    )
                                                    .format("H:mm:ss")}
                                                </td>
                                                <td>
                                                  {moment
                                                    .utc(
                                                      +moment.duration(
                                                        moment().diff(
                                                          moment(
                                                            x.graderOutWardStock
                                                              ?.createdAt
                                                          )
                                                        )
                                                      )
                                                    )
                                                    .format("H:mm:ss")}
                                                </td>
                                                <td scope="row">
                                                  {(x?.graderOutWardStock
                                                    ?.totalOutwardWeight || 0) +
                                                    " CT"}
                                                </td>
                                              </>
                                            )}
                                          </tr>
                                          {/* <tr>
                                        {x.salesOfficeOutWardStock != null && (
                                          <>
                                            <td scope="row"> Sales Office </td>

                                            <td>
                                              {moment(
                                                x.salesOfficeOutWardStock
                                                  .createdAt
                                              ).format("hh:mm:ss A")}
                                            </td>
                                            <td>
                                              {moment(
                                                x.salesOfficeOutWardStock
                                                  .updatedAt
                                              ).format("hh:mm:ss A")}
                                            </td>
                                            <td>
                                              {moment
                                                .utc(
                                                  +moment.duration(
                                                    moment(
                                                      x.salesOfficeOutWardStock
                                                        .updatedAt
                                                    ).diff(
                                                      moment(
                                                        x
                                                          .salesOfficeOutWardStock
                                                          .createdAt
                                                      )
                                                    )
                                                  )
                                                )
                                                .format("H:mm:ss")}
                                            </td>
                                            <td>
                                              {moment
                                                .utc(
                                                  +moment.duration(
                                                    moment(
                                                      x.salesOfficeOutWardStock
                                                        ?.createdAt
                                                    ).diff(
                                                      moment(
                                                        x.dataEntryOutWardStock
                                                          .updatedAt
                                                      )
                                                    )
                                                  )
                                                )
                                                .format("H:mm:ss")}
                                            </td>
                                          </>
                                        )}
                                      </tr> */}
                                        </tbody>
                                      </table>
                                    </div>

                                    <div className="table-responsive">
                                      <table className="table border table-responsive background-light foo border-1">
                                        <thead>
                                          <tr>
                                            <th scope="col">
                                              {this.props.t("SR No.")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Cube Id")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Grader User Name")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Pieces")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Weight / Carat")}
                                            </th>

                                            <th scope="col">
                                              {this.props.t("Cycle")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Process")}
                                            </th>

                                            <th scope="col">
                                              {this.props.t("Accept Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Assign Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Hold Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Delay Time")}
                                            </th>
                                          </tr>
                                        </thead>
                                        {this.state.graderOutWards
                                          .sort(
                                            (a, b) =>
                                              a[0]?.cubeBelt?.cubeId?.split(
                                                "-"
                                              )[1] -
                                              b[0]?.cubeBelt?.cubeId?.split(
                                                "-"
                                              )[1]
                                          )
                                          .map((y, index) => {
                                            return (
                                              <tbody key={index}>
                                                <tr>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      y[0].stockDataEntryInWard
                                                        .srNo
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {y[0]?.cubeBelt?.cubeId}
                                                  </td>

                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      this.state.jangadTimeline
                                                        .jangads[0]?.graderStock
                                                        ?.user?.name
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                  >
                                                    {
                                                      y[0].stockDataEntryInWard
                                                        .pieces
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                  >
                                                    {
                                                      y[0].stockGraderInWard
                                                        .weight
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      y[0]
                                                        .assignGraderToFillerInWard
                                                        .cycle
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      y[0]
                                                        .assignGraderToFillerInWard
                                                        .process.name
                                                    }
                                                  </td>

                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                  >
                                                    {moment(
                                                      y[1]?.graderOutward
                                                        .createdAt
                                                    ).format("hh:mm:ss A")}
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                  >
                                                    {moment(
                                                      y[1]?.graderOutward
                                                        .updatedAt
                                                    ).format("hh:mm:ss A")}
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                  >
                                                    {moment
                                                      .utc(
                                                        +moment.duration(
                                                          moment(
                                                            y[1]?.graderOutward
                                                              .updatedAt
                                                          ).diff(
                                                            moment(
                                                              y[1]
                                                                ?.graderOutward
                                                                .createdAt
                                                            )
                                                          )
                                                        )
                                                      )
                                                      .format("H:mm:ss")}
                                                  </td>
                                                  <td
                                                    className={
                                                      y[0].graderStatus ==
                                                        "A" ||
                                                      y[0].machineOperatorStock
                                                        .boilManUserId == null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                  >
                                                    {moment
                                                      .utc(
                                                        +moment.duration(
                                                          moment(
                                                            machineOperatorUpdatedDate
                                                          ).diff(
                                                            y[1]?.graderOutward
                                                              .createdAt
                                                          )
                                                        )
                                                      )
                                                      .format("H:mm:ss")}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            );
                                          })}
                                      </table>
                                    </div>
                                  </>
                                )}

                                {x.dataEntryOutWardStock != null && (
                                  <>
                                    <h4 className="text-center fw-bold pt-3">
                                      {this.props.t("Data Entry Outward Stock")}
                                    </h4>
                                    <div className="table-responsive">
                                      <table className="table border table-responsive background-light foo border-1">
                                        <thead>
                                          <tr>
                                            <th scope="col">
                                              {this.props.t("Office")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Accept Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Assign Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Hold Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Delay Time")}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            className={
                                              x.dataEntryOutWardStock != null
                                                ? "bg-success-green"
                                                : "btn-orange"
                                            }
                                          >
                                            {x.dataEntryOutWardStock !=
                                              null && (
                                              <>
                                                <td scope="row">
                                                  {" "}
                                                  {this.props.t(
                                                    "Data Entry"
                                                  )}{" "}
                                                </td>

                                                <td>
                                                  {moment(
                                                    x.dataEntryOutWardStock
                                                      .createdAt
                                                  ).format("hh:mm:ss A")}
                                                </td>
                                                <td>
                                                  {moment(
                                                    x.dataEntryOutWardStock
                                                      .updatedAt
                                                  ).format("hh:mm:ss A")}
                                                </td>
                                                <td>
                                                  {moment
                                                    .utc(
                                                      +moment.duration(
                                                        moment(
                                                          x
                                                            .dataEntryOutWardStock
                                                            .updatedAt
                                                        ).diff(
                                                          moment(
                                                            x
                                                              .dataEntryOutWardStock
                                                              .createdAt
                                                          )
                                                        )
                                                      )
                                                    )
                                                    .format("H:mm:ss")}
                                                </td>
                                                <td>
                                                  {moment
                                                    .utc(
                                                      +moment.duration(
                                                        moment(
                                                          x
                                                            .dataEntryOutWardStock
                                                            ?.createdAt
                                                        ).diff(
                                                          moment(
                                                            x.graderOutWardStock
                                                              .updatedAt
                                                          )
                                                        )
                                                      )
                                                    )
                                                    .format("H:mm:ss")}
                                                </td>
                                              </>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>

                                    <div className="table-responsive">
                                      <table className="table border table-responsive background-light foo border-1">
                                        <thead>
                                          <tr>
                                            <th scope="col">
                                              {this.props.t("SR No.")}
                                            </th>

                                            <th scope="col">
                                              {this.props.t(
                                                "Data Entry User Name"
                                              )}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Pieces")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Weight / Carat")}
                                            </th>

                                            <th scope="col">
                                              {this.props.t(
                                                "outward Weight / Carat"
                                              )}
                                            </th>

                                            <th scope="col">
                                              {this.props.t("Cycle")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Process")}
                                            </th>

                                            <th scope="col">
                                              {this.props.t("Accept Time")}
                                            </th>
                                            <th scope="col">
                                              {this.props.t("Assign Time")}
                                            </th>
                                          </tr>
                                        </thead>
                                        {this.state.dataEntryOutwardStockList.map(
                                          (x, index) => {
                                            return (
                                              <tbody key={index}>
                                                <tr>
                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      x.stockDataEntryInWard
                                                        .srNo
                                                    }
                                                  </td>

                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      this.state.jangadTimeline
                                                        .jangads[0]
                                                        ?.dataEntryOutWardStock
                                                        ?.user?.name
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      x.stockDataEntryInWard
                                                        .pieces
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {x.weight}
                                                  </td>

                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {x.outWardWeight}
                                                  </td>
                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {
                                                      this.state.jangadTimeline
                                                        .jangads[0].cycle
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {x?.process?.name}
                                                  </td>

                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {moment(
                                                      x.stockDataEntryInWard
                                                        .outwardDate
                                                    ).format("hh:mm:ss A")}
                                                  </td>

                                                  <td
                                                    className={
                                                      x.stockDataEntryInWard
                                                        .outwardDate != null
                                                        ? "bg-success-green"
                                                        : "btn-orange"
                                                    }
                                                    scope="row"
                                                  >
                                                    {moment(
                                                      x.stockDataEntryInWard
                                                        .grader_outward_date
                                                    ).format("hh:mm:ss A")}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            );
                                          }
                                        )}
                                      </table>
                                    </div>
                                  </>
                                )}
                              </div>
                            </>
                          );
                        })}
                      </>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(ViewJangadTimeline);
